<template>
  <fullscreen ref="fullscreen">
  <hooper ref="slides" :progress="false" :playSpeed="config.slide_time" :transition="1500" :autoPlay="!paused" :infiniteScroll="true" :hoverPause="false" @slide="enterSlide">
  <slide v-for="(item, hkey, idx) of slides" v-bind:key="hkey" v-bind:index="idx"
         v-bind:style="{ 'background-image': 'url(' + (item.bg ? item.bg.url : '' ) + ')' }"
         v-bind:class="[ item.tklass ]"
  >
  <div class="textbox" >
        <h1 class="headline" v-bind:title="'version created ' + item.version_created"><span>{{ item.headline }} </span></h1>
      <div class="teaserbox">
       <p class="teaser" v-html="item.article_html"></p>
       <p class="updated" v-if="ago(item)" v-bind:title="item.version_created">
             Aktualisiert {{ ago(item) }}.
       </p>
      </div>
  </div>
  <div class="ressort" @click="togglePause()">
     <span class="ressort-text" v-html="paused ? item.ressort + ' ||' : item.ressort + '' "></span>
  </div>
  </slide>
  </hooper>
  <section class="chyron" v-bind:title="version.git_describe + ' ' + version.timestamp">
      <div class="logobox" v-bind:class="tapClass" v-on:mousedown="tap('down')" v-on:mouseup="tap('up')" v-on:touchstart.prevent="tap('down')" v-on:touchend.prevent="tap('up')">
          <div class="logo">
          </div>
      </div>
      <div class="timebox" @click="toggleFullscreen">
          <div class="timebox-wrapper">
              <div><span :key="timebox">{{ new Date() | moment("HH:mm") }}</span></div>
              <div><span :key="timebox">{{ new Date() | moment("D. M.") }}</span></div>
          </div>
      </div>
  <marquee-text :duration="config.ticker_duration"><span :data-urn="item.urn" class="chyrontext" v-for="(item, key, indx) in ticker" :key="key" :index="indx">{{ item.headline }}</span></marquee-text>
  </section>
  <section v-if="overlay" id="overlay">
      <div class="ui-close" v-on:click="overlay = false">Close Overlay</div>
      <h2>dpa - newsscreen 2</h2>
      <pre> <span v-if="version.url">{{ version. url }}</span> git_describe {{ version.git_describe }} - {{ version.timestamp }} </pre>
        <h2> Slides </h2>
        <ol>
            <li v-for="(item, hkey, idx) of slides" v-bind:key="hkey" v-bind:index="idx" v-bind:title="item.urn">
                <div class="slideItem" v-on:click="toSlide(idx)">{{ item.urn.slice(28) }} - {{ item.headline }}
                    <span class="update-hint" v-if="ago(item)">Aktualisiert vor {{ ago(item) }}</span>

                </div>
            </li>
        </ol>
        <h2> Ticker </h2>
        <ol>
            <li v-for="(item, hkey, idx) of ticker" v-bind:key="hkey" v-bind:index="idx" v-bind:title="item.urn">
                {{ item.urn.slice(28) }} - {{ item.headline }}
                <span class="update-hint" v-if="ago(item)">Aktualisiert vor {{ ago(item) }}</span>
            </li>
        </ol>
        &copy; 2021 dpa-newslab GmbH
  </section>
  </fullscreen>
</template>

<script>
import './css/app.css'
import MarqueeText from 'vue-marquee-text-component'
import fullscreen from 'vue-fullscreen'
import Vue from 'vue'
import lib from './lib'
import config from './config'

import {
  Hooper,
  Slide
} from 'hooper'

Vue.use(fullscreen)

window.data = {
  slides: { 'start':
      { headline: 'Loading ...', article_html: 'Please wait.', ressort: ' ' }
  },
  ticker: { 'start': { headline: '...' } },
  paused: false,
  timebox: 1,
  tapClass: '',
  config:
    {
      slide_time: config.slide_time,
      ticker_duration: config.ticker_duration,
      solution: config.solution,
      updateTimeString: config.updateTimeString
    },
  overlay: false,
  version: { git_describe: '', timestamp: '' },
  loaded: new Date()
}

export default {
  components: {
    MarqueeText,
    Hooper,
    Slide
  },
  data () {
    return window.data
  },
  methods: {

    toSlide: function (slide) {
      this.$refs.slides.slideTo(slide)
    },

    toggleFullscreen: function () {
      this.$refs['fullscreen'].toggle()
    },

    forceFullscreen: function () {
      /* can only be initiated by user */
      if (config.force_fullscreen) {
        try {
          if (!(this.$refs['fullscreen'].getState())) {
            this.$refs['fullscreen'].toggle()
          }
        } catch (e) {
          console.log(`Fullscreen force failed: ${e}`)
        }
      }
    },

    togglePause: function () {
      /* window.data.paused = !window.data.paused */
      /* Vue.set(this.$refs.slides, 'autoPlay', window.data.autoPlay) */
    },

    enterSlide: function (param) {
      const slideDom = document.getElementsByClassName('hooper-slide')[param.currentSlide]
      const bodyDom = document.getElementsByTagName('body')[0]

      lib.setClasses({ source: slideDom, destination: bodyDom, search: '-slide', replace: '-body' })
    },

    ago: function (item) {
      return this.config.updateTimeString(this.loaded, item)
    },
    tap: function (message) {
      const p = lib.morseReceiver.process(message, this.config.solution)
      if (p === 'OK') {
        window.data.overlay = true
        window.data.tapClass = ''
      } else {
        window.data.tapClass = p
      }
    }
  }

}

/*
window.oncontextmenu = function (event) {
  event.preventDefault()
  event.stopPropagation()
  return false
}
*/

</script>
